import { Components } from './styled';
import ProjectTable from '../../../../../components/ProjectTable';
import { tableColumns } from '../../../../../components/ProjectTable/constants';
import React from 'react';
import { Lesson } from '../../../../../api/types/lesson';
import { ContentGroup } from '../../../../../api/types/contentGroup';
import useModalState from '../../../../../hooks/useModalState';
import ConfirmationModal from '../../../../../components/modals/ConfirmationModal';
import { confirmationTexts } from '../../../../../components/modals/ConfirmationModal/utils';

const ItemsComponent = ({
  contentGroupType,
  items,
  freeItems,
  onEditItem,
  onAddItems,
  onRemoveItem,
  onAddFreeItems,
  onRemoveFreeItem,
  onMoveUpItem,
  onMoveDownItem,
}: {
  contentGroupType: string;
  items: (Lesson | ContentGroup)[];
  freeItems: string[];
  onEditItem: (id: string | undefined) => void;
  onAddItems: () => void;
  onRemoveItem: (id: string | undefined) => void;
  onAddFreeItems: () => void;
  onRemoveFreeItem: (id: string | undefined) => void;
  onMoveUpItem: (id: string | undefined) => void;
  onMoveDownItem: (id: string | undefined) => void;
}) => {
  const confirmationModalForEditItem = useModalState<{ id: string | undefined }>();
  const confirmationModalForRemoveItem = useModalState<{ id: string | undefined }>();

  const onConfirmCancelForEditItem = () => {
    onEditItem(confirmationModalForEditItem?.modalState?.id);
  };
  const onConfirmCancelForRemoveItem = () => {
    onRemoveItem(confirmationModalForRemoveItem?.modalState?.id);
  };

  return (
    <>
      {contentGroupType === 'collection' && (
        <Components.FieldWrapper>
          <Components.FieldLabel>Lessons in this collection</Components.FieldLabel>
          <Components.TableWrapper>
            <ProjectTable
              data={items || []}
              columns={tableColumns.lessonsInCollection({
                onEdit: (id) => {
                  confirmationModalForEditItem.open({ id: id });
                },
                onRemove: (id) => {
                  confirmationModalForRemoveItem.open({ id: id });
                },
                onMoveUp: (id) => {
                  onMoveUpItem(id);
                },
                onMoveDown: (id) => {
                  onMoveDownItem(id);
                },
              })}
            />
          </Components.TableWrapper>
          <Components.ModalButtonsContainer>
            <Components.UploadButton onClick={onAddItems}>Add Lessons</Components.UploadButton>
          </Components.ModalButtonsContainer>
        </Components.FieldWrapper>
      )}

      {contentGroupType === 'collection' && !!items && items?.length > 0 && (
        <Components.FieldWrapper>
          <Components.FieldLabel>Free lessons</Components.FieldLabel>
          <Components.TableWrapper>
            <ProjectTable
              data={freeItems.map((freeItemId) => items.filter((item) => item?.id === freeItemId)[0]) || []}
              columns={tableColumns.lessonsInCollection({
                onEdit: (id) => {
                  confirmationModalForEditItem.open({ id: id });
                },
                onRemove: (id) => onRemoveFreeItem(id),
              })}
            />
          </Components.TableWrapper>
          <Components.ModalButtonsContainer>
            <Components.UploadButton onClick={onAddFreeItems}>Select Free Lessons</Components.UploadButton>
          </Components.ModalButtonsContainer>
        </Components.FieldWrapper>
      )}

      {contentGroupType === 'bundle' && (
        <Components.FieldWrapper>
          <Components.FieldLabel>Collections in this bundle</Components.FieldLabel>
          <Components.TableWrapper>
            <ProjectTable
              data={items || []}
              columns={tableColumns.collectionsInBundle({
                onEdit: (id) => {
                  confirmationModalForEditItem.open({ id: id });
                },
                onRemove: (id) => {
                  confirmationModalForRemoveItem.open({ id: id });
                },
                onMoveUp: (id) => {
                  onMoveUpItem(id);
                },
                onMoveDown: (id) => {
                  onMoveDownItem(id);
                },
              })}
            />
          </Components.TableWrapper>
          <Components.ModalButtonsContainer>
            <Components.UploadButton onClick={onAddItems}>Add Collections</Components.UploadButton>
          </Components.ModalButtonsContainer>
        </Components.FieldWrapper>
      )}

      <ConfirmationModal
        {...confirmationModalForEditItem}
        confirmationText={confirmationTexts.contentGroups.cancelEditingForEditItem}
        onConfirm={onConfirmCancelForEditItem}
      />
      <ConfirmationModal
        {...confirmationModalForRemoveItem}
        confirmationText={confirmationTexts.contentGroups.removeItem}
        onConfirm={onConfirmCancelForRemoveItem}
      />
    </>
  );
};

export default ItemsComponent;
